import type {RenderImageContext, RenderImageProps} from 'react-photo-album';
import Image from 'next/image';

import type {ImageWeb} from '@/modules/foundation/components/image/types';

export function renderNextImage(
	{alt = '', title, sizes}: RenderImageProps,
	{photo, width, height}: RenderImageContext,
) {
	return (
		<div
			style={{
				width: '100%',
				position: 'relative',
				aspectRatio: `${width} / ${height}`,
			}}
		>
			<Image
				fill
				src={photo}
				alt={alt}
				title={title}
				sizes={sizes}
				placeholder={'blurDataURL' in photo ? 'blur' : undefined}
				className="rounded-sm"
			/>
		</div>
	);
}

export function galleryImageFromImageWeb(image: ImageWeb) {
	return {
		src: image.image.src,
		width: image.image.width,
		height: image.image.height,
		alt: image.altText ?? '',
	};
}
